/**
 * Release notes, newest first. Hand-written on purpose: commit subjects are
 * written for us, and this is written for whoever is holding the phone.
 *
 * Adding a release: bump `version` in package.json to match the top entry here,
 * or the menu will advertise a version that has no notes.
 */
export interface Release {
  version: string
  /** ISO date, `YYYY-MM-DD`. */
  date: string
  changes: string[]
}

export const RELEASES: Release[] = [
  {
    version: '0.4.0',
    date: '2026-08-18',
    changes: [
      'Nudge sends email now. New accounts get a welcome and a link to confirm their address.',
      'Forgot your password? There is finally a way out, from the sign-in screen.',
      'Invite someone to your household by email — the message carries the same code the Household tab shows.',
      'Confirming your address is optional. It unlocks account recovery, and until then you get a banner you can dismiss, never a locked door.',
      'The app has a favicon.',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-08-17',
    changes: [
      'New admin console at /admin for staff accounts, linked from Profile when you have access.',
      'Overview with live counts, a 7/30/90-day activity chart, and what people are actually binding reminders to.',
      'User management: search, plan changes, suspension with a reason, password recovery, staff notes and account deletion.',
      'Browse every reminder, household, cached store and nudge that has fired — the answer to "why did (or didn’t) it go off?".',
      'System page showing build versions, database size, effective configuration, and a button to check whether the OpenStreetMap mirrors are alive.',
      'Push broadcast, which previews its audience before it can send.',
      'Every staff change is written to an audit trail that survives the account that made it.',
      'Suspended accounts now see a clear message instead of a silent failure.',
    ],
  },
  {
    version: '0.2.0',
    date: '2026-08-17',
    changes: [
      'Categories are yours now — create, rename, recolour, re-icon and delete them. You can add one mid-reminder without losing your place.',
      'Deleting a category never deletes its reminders; they simply become uncategorized until you file them again.',
      'New Done list — everything you have ticked off, grouped by day, showing who closed each one.',
      'Restore a completed reminder back to your list, or delete it for good.',
      'The app now shows its version and build time, with these release notes, under the ••• menu.',
      'Fixed: "Install app" never appeared. The app icons were returning 404 in production, and Chrome quietly withholds the install prompt when that happens.',
    ],
  },
  {
    version: '0.1.0',
    date: '2026-08-17',
    changes: [
      'First release.',
      'Reminders bind to a kind of place — "any supermarket", "any Best Buy" — instead of one pin on a map.',
      'Nudges you when you are near any matching store that is actually open right now.',
      'Household sharing, with Ping to reach someone even when their app is closed.',
      'Map view, category filters, and a free tier of 5 active reminders.',
    ],
  },
]
